import Link from 'next/link'
import React from 'react'

function UnlockModal({style , close}:{style:{ [key: string]: string }, close:()=>void}) {
  return (
    <div className={style.modalBox}>
        <div className={style.modalBoxBg}>
          <div className={style.UnlockDramaContent}>
            <button type="button" className={style.close} onClick={close}>
              <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#ffffff"><path d="m291-240-51-51    189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" /></svg>
            </button>
            <h2>Unlock the</h2>
            <h3>DRAMA!</h3>
            <p>Upgrade to DramaFlicks Pro to unlock all episodes</p>
            <div className={style.joinBtn}>
              <Link href="/premium" onClick={close}>Join Premium</Link>
            </div>
          </div>
        </div>
      </div>
  )
}

export default UnlockModal